import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAppContext } from '../context/AppContext';
import emailjs from 'emailjs-com';

// Initialize EmailJS
emailjs.init('YboBNkGJIkopKVK2t');  // Replace with your actual User ID

const PageContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 40px;
  
  h1 {
    font-size: 2.5rem;
    color: #fff;
    margin-bottom: 10px;
  }
`;

const ContactUsSection = styled.div`
  margin-top: 40px;
  background-color: rgb(57, 56, 56);
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  h2 {
    font-size: 2rem;
    margin-bottom: 20px;
    text-align: center;
    color: #ffffff;
  }
  
  p {
    text-align: center;
    margin-bottom: 20px;
    color: #ff1;
  }
  
  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  input,
  textarea {
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100%;
  }
  
  button {
    background-color: #4a90e2;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 4px;
    font-size: 1.1rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s;
    align-self: center;
    
    &:hover {
      background-color: #357abd;
    }
    
    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }
  }
`;

const TryOnPage = () => {
  const { userImage, measurements } = useAppContext();
  const navigate = useNavigate();
  const [contactForm, setContactForm] = useState({ name: '', email: '', message: '' });

  useEffect(() => {
    if (!measurements || !userImage) {
      navigate('/measurements');
    }
  }, [measurements, userImage, navigate]);

  const handleContactFormChange = (e) => {
    const { name, value } = e.target;
    setContactForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSubmitContactForm = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_jgwjfzl',  // Your Service ID
        'template_c2szumf',  // Your EmailJS Template ID
        e.target,
        'YboBNkGJIkopKVK2t'  // Your Public Key (User ID)
      )
      .then(
        (response) => {
          alert('Message sent successfully!');
          setContactForm({ name: '', email: '', message: '' });
        },
        (error) => {
          console.error('Error sending message:', error);
          alert('Failed to send the message. Please try again.');
        }
      );
  };

  return (
    <PageContainer>
      <Header>
        <h1>Virtual Try-On</h1>
      </Header>
      
      <ContactUsSection>
        <h2>Contact Us for a Demo</h2>
        <p>We provide AR/AI solutions and VR is coming soon! Fill out the form below to request a demo.</p>
        <form onSubmit={handleSubmitContactForm}>
          <input 
            type="text" 
            name="name" 
            value={contactForm.name} 
            onChange={handleContactFormChange} 
            placeholder="Your Name" 
            required
          />
          <input 
            type="email" 
            name="email" 
            value={contactForm.email} 
            onChange={handleContactFormChange} 
            placeholder="Your Email" 
            required
          />
          <textarea 
            name="message" 
            value={contactForm.message} 
            onChange={handleContactFormChange} 
            placeholder="Your Message" 
            required
          />
          <button type="submit">Send Message</button>
        </form>
      </ContactUsSection>

      <button onClick={() => navigate('/measurements')}>← Back to Measurements</button>
    </PageContainer>
  );
};

export default TryOnPage;
